import { createSolanaWalletProvider, unwrapSolanaProviderRequest, } from '@farcaster/miniapp-core';
import { miniAppHost } from "./miniAppHost.js";
const { solanaProviderRequest } = miniAppHost;
let solanaProvider;
if (solanaProviderRequest) {
    solanaProvider = createSolanaWalletProvider(unwrapSolanaProviderRequest(solanaProviderRequest));
}
async function getSolanaProvider() {
    let capabilities;
    try {
        capabilities = await miniAppHost.getCapabilities();
    }
    catch { }
    if (!capabilities?.includes('wallet.getSolanaProvider')) {
        return undefined;
    }
    return solanaProvider;
}
export { getSolanaProvider };
